APP.Dashboard = (/** @lends APP.Dashboard */function () {
	'use strict';

	var exports,
		$body,
		inited = false,
		setupInited = false,
		dashboardType,
		filled = {},
		availableTabs = [false, false, false, false, false, false, false, false, false, false, false];

	function init() {
		var i, l = availableTabs.length;

		$body = APP.Performance.getCachedDOM().$body;
		dashboardType = $body.find('[data-dashboard]').attr('data-dashboard') || false;

		if (inited === false) {
			inited = true;

			if (dashboardType === 'post') {
				APP.AsyncModule.onRequest('extra-info', function (response) {
					if (response && response.data && response.data.async && setupInited === false) {
						if (response.data.async.unFilled && response.data.async.unFilled.length === 0) {

							setUpAllowances(response.data);
							setUpSubTabs(response.data);

							for (i = 0; i < l; i++) {
								if (availableTabs[i] === true) {
									showTab(APP.Chart.getId(), i);
									break;
								}
							}

							setupInited = true;
						}
					}
				});
			}

			initBindings();

		}

	}

	function showTab(id, index) {
		window.setTimeout(function () {
			APP.Chart.changeLineChartTab('chart-element-' + id, index, true);
		}, 250);
	}

	function initBindings() {
		$body.on({
			click: function () {
				var type;

				type = $(this).parents('[data-campaign-impression]') && $(this).parents('[data-campaign-impression]').attr('data-campaign-impression');
				if ($(this).attr('href')) {
					if($(this).attr('data-campaign-callback') === 'campaign') {
						APP.Analytics.trackEvent('callback consumer', 'click', type);
					} else {
						APP.Analytics.trackEvent('Subscription', 'Offer Type', type);
					}
				}

			}
		}, '[data-offer-tracking] a');
	}

	function campaignImpression() {
		var offers = [],
			i, l;

		if ($body.find('[data-campaign]').length > 0) {

			offers = $body.find('[data-campaign-impression]');

			l = offers.length;
			for (i = 0; i < l; i++) {
				APP.Analytics.trackEvent('Subscription', 'Offer', 'Impression type - ' + $(offers[i]).attr('data-campaign-impression'));
				APP.Analytics.trackPromoView($(offers[i]).attr('data-campaign-impression'), i + 1);
				APP.Analytics.trackPromoClick($(offers[i]), i + 1);
			}

			if (typeof $body.find('[data-campaign]').attr('data-scroll-to-campaigns') !== 'undefined') {
				scrollToCampaigns();
			}
		}

	}

	function scrollToCampaigns() {
		if ($body.find('[data-campaign]').length > 0) {
			$('html, body').animate({
				scrollTop: $('[data-campaign]').offset().top - 100
			}, 2000);
		}
	}

	function setUpAllowances(data) {
		var key,
			allowance = data.allowance,
			installment = data.installment,
			needFillDate = true,
			i;

		if (data.async.unFilled.allowance || filled.allowance) {
			return false;
		}

		filled.allowance = true;

		if (installment && installment.contractId) {
			allowance[5] = [true];
		}

		for (key in allowance) {
			if (allowance.hasOwnProperty(key) && allowance[key].length > 0) {
				availableTabs[key] = true;

				for (i = 0; i < allowance[key].length; i++) {
					needFillDate = true;

					if (allowance[key][i].unknownQuota && data.details[key] && data.details[key][i] && data.details[key][i].table) {
						needFillDate = false;
					}

					if (typeof allowance[key][i] !== 'boolean') {
						allowance[key][i].needFillDate = needFillDate && allowance[key][i].fillDateTime !== '';
					}
				}

				$body.find('[data-line-chart-tab-content="' + key + '"] [data-chart-wrapper]').html(
					APP.Template.get('pie-charts')(allowance[key])
				);
				APP.Tooltip.reposition();
			}
		}

		$body.find('[data-line-chart-tab]').attr('data-line-chart-tab', 1000);

		APP.Chart.init();
	}

	function setUpSubTabs(data) {
		var key,
			details = data.details,
			installment = data.installment;

		if (data.async.unFilled.details || filled.details) {
			return false;
		}

		if (installment && installment.contractId) {
			details[5] = [installment];
		}

		filled.details = true;

		for (key in details) {
			if (details.hasOwnProperty(key) && details[key].length > 0) {
				availableTabs[key] = true;
				if (parseInt(key, 10) === 5 && installment !== undefined) {
					$body.find('[data-line-chart-tab-content="' + key + '"] [data-installment-wrapper]').html(
						APP.Template.get('installment-details')(installment)
					);
				} else {
					$body.find('[data-line-chart-tab-content="' + key + '"] [data-tab-active]').html(
						APP.Template.get('sub-tabs')(details[key])
					);
				}
				APP.Tooltip.reposition();
			}
		}

		setUpButtonVisibility(data);
	}

	function setUpButtonVisibility(data) {
		var i, css = '';

		for (i = 0; i < availableTabs.length; i++) {
			if (!availableTabs[i]) {
				css += '.button--nth-' + i + ' { visibility:hidden; pointer-events:none }';
				css += 'svg [cursor="pointer"]:nth-child(' + i + ') { cursor:default !important; }';
			}
		}
		$body.find('[data-button-styles]').html(css);
		$body.find('[data-tab-select]').html(function () {
			var selectHtml = '',
				key,
				entries = data.cost.entries;

			for (key in entries) {
				if (entries.hasOwnProperty(key) && availableTabs[parseInt(key, 10) + 1]) {
					selectHtml += '<option value="' + (parseInt(key, 10) + 1) + '">' + entries[key].label + ' részletei</option>';
				}
			}

			return selectHtml;

		}).on('change', function () {
			APP.Chart.changeLineChartTab($body.find('[data-line-chart]').attr('id'), $(this).val());
		}).parents('[style]').first().attr('style', '');
	}

	exports = {
		init: init,
		campaignImpression: campaignImpression
	};

	return exports;

}());
